import React from 'react';

import { useExperimentalResultsExport } from 'services/export/useExperimentalResultsExport';
import ExperimentalStudyExportMenu from './ExperimentalStudyExportMenu';
import LegacyStudyExportMenu from './LegacyStudyExportMenu';

// Release 1 keeps the existing export menu; the Export data chooser is opt-in until Release 3.
const StudyExportMenu: React.FunctionComponent<React.ComponentProps<typeof LegacyStudyExportMenu>> = (props) =>
  useExperimentalResultsExport() ? <ExperimentalStudyExportMenu {...props} /> : <LegacyStudyExportMenu {...props} />;

export default StudyExportMenu;
